import React from 'react';
import { Link } from 'react-router-dom';

function BagIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
      <path d="M16 10a4 4 0 01-8 0"/>
    </svg>
  );
}
function UserIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  );
}
function MapPinIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  );
}
function LogOutIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  );
}

const NAV_ITEMS = [
  { key: 'orders',    to: '/account/orders',    icon: BagIcon,    label: 'Orders' },
  { key: 'details',   to: '/account/details',   icon: UserIcon,   label: 'Account details' },
  { key: 'addresses', to: '/account/addresses', icon: MapPinIcon, label: 'Addresses' },
];

export default function AccountSidebar({ user, onLogout, active }) {
  const displayName = user
    ? `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email
    : 'Plant Lover';
  const initials = displayName.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'PL';

  return (
    <aside className="ord-sidebar">
      <div className="ord-profile">
        <div className="ord-avatar">{initials}</div>
        <div>
          <p className="ord-profile__name">{displayName}</p>
          <p className="ord-profile__email">{user?.email || ''}</p>
        </div>
      </div>

      <nav className="ord-nav">
        {NAV_ITEMS.map(({ key, to, icon: Icon, label }) => (
          <Link
            key={key}
            to={to}
            className={`ord-nav__item${active === key ? ' ord-nav__item--active' : ''}`}
          >
            <Icon /> {label}
          </Link>
        ))}
        <button className="ord-nav__item ord-nav__item--logout" onClick={onLogout}>
          <LogOutIcon /> Log out
        </button>
      </nav>
    </aside>
  );
}